<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.base.user-management.header"></app-title-bar>
<div class="row align-items-center">
  <div class="col-12">
    <div  class="d-flex align-items-center mb-2">
      <app-client-autocomplete [(selectedClient)]="selectedClient" [showSystem]="true" class="client-autocomplete me-2"></app-client-autocomplete>
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <ejs-grid #grid
              class="grid-with-toolbar grid-with-footer"
              width='100%'
              rowHeight='38'
              [dataSource]="data"
              [allowFiltering]='true'
              [filterSettings]='filterSettings'
              [allowSorting]='true'
              [pageSettings]='pageSettings'
              [allowPaging]='true'
              [editSettings]="editSettings"
              [searchSettings]="searchOptions"
              (actionComplete)="actionComplete($event)"
              (actionBegin)="actionBegin($event)"
              (rowDataBound)="onRowDataBound($event)"
              (commandClick)="commandClick($event)">
      <ng-template #toolbarTemplate let-data>
        <ejs-toolbar>
          <e-items>
          @if(isUserAdmin) {
            <e-item [disabled]="!selectedClient" [text]="'i18n.base.user-management.buttons.proxy' | translate" prefixIcon="e-icons icon-add" (click)="addUser(Role.Proxy)"></e-item>
          }
            <e-item [text]="'i18n.base.user-management.buttons.web-mobile' | translate" prefixIcon="e-icons icon-add" (click)="addUser(Role.ClientUser)"></e-item>
            <e-item [disabled]="!selectedClient" [text]="'i18n.base.user-management.buttons.parking-ranger' | translate" prefixIcon='e-icons icon-add' (click)="addUser(Role.ParkingRanger)"></e-item>
            <e-item [text]="'i18n.base.user-management.buttons.third-party-user' | translate" prefixIcon='e-icons icon-add' (click)="addUser(Role.ThirdPartyParkingControl)"></e-item>
          </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        <e-column headerText='id' field='userId' [visible]='false' [isPrimaryKey]='true'></e-column>
        <e-column type="string" [headerText]="'i18n.base.user-management.column-headers.firstName' | translate" field="firstname" clipMode='EllipsisWithTooltip'></e-column>
        <e-column type="string" [headerText]="'i18n.base.user-management.column-headers.lastName' | translate" field="lastname" clipMode='EllipsisWithTooltip'></e-column>
      @if(!hideClient()) {
        <e-column [headerText]="'i18n.base.user-management.column-headers.client' | translate" field="client.name" type="string" clipMode='EllipsisWithTooltip'></e-column>
      }
        <e-column [headerText]="'i18n.base.user-management.column-headers.company' | translate" field="company.name" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.email' | translate" field="email" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.username' | translate" field="userName" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.coordinates' | translate" field="addressCoordinates" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.address' | translate" field="fullAddress" clipMode='EllipsisWithTooltip' [filter]="languageFilter"></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.role' | translate" field="roles" clipMode='EllipsisWithTooltip' [filter]="roleFilter">
          <ng-template #filterItemTemplate let-data>{{formatRoles(data)}}</ng-template>
          <ng-template #template let-data>
            <span>{{formatRoles(data)}}</span>
          </ng-template>
        </e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.enabled' | translate"
                  field="enabled"
                  [visible]='showInactive'
                  width="160px"
                  [filter]="isActiveFilter">
          <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'enabled')}}</ng-template>
          <ng-template #template let-data>
          @if(data.enabled) {
            <div class="e-icons icon-checkmark align-middle"></div>
          }
          </ng-template>
        </e-column>
        <e-column id="commands" headerText="" [commands]='customGridCommands' width='170px'></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate let-data>
      @if(!useProxyUserForm && !useThirdPartyUserForm) {
        <app-user-edit-form [userEditForm]="gridEditForm"
                            [selectedUser]="data"
                            [selectedClientId]="selectedClient?.id"></app-user-edit-form>
      } @else if(!useThirdPartyUserForm) {
        <app-proxy-edit-form [proxyEditForm]="gridEditForm"
                             [selectedClientId]="selectedClient?.id"></app-proxy-edit-form>
      } @else {
        <app-tpu-edit-form [thirdPartyUserEditForm]="gridEditForm"
                                [selectedClientId]="selectedClient?.id"></app-tpu-edit-form>
      }
      </ng-template>
    </ejs-grid>
  </div>
</div>
